import React from "react";
import { ProcessTreeItem as IProcessTreeItem } from "../../../../@types";
import ProcessTreeItem from "./ProcessTreeItem";

const createNode = (process: IProcessTreeItem, showAdditionalInfo = true) => (
  <ProcessTreeItem
    key={`${process.name}_${process.process_id}_${process.parameters}`}
    process={process}
    showAdditionalInfo={showAdditionalInfo}
  >
    <ul>
      {(process?.children || []).map(child =>
        createNode(child, showAdditionalInfo)
      )}
    </ul>
  </ProcessTreeItem>
);

export const createTree = (
  data: Array<IProcessTreeItem>,
  showAdditionalInfo = true
) =>
  (data || []).map((item: IProcessTreeItem) =>
    createNode(item, showAdditionalInfo)
  );
